var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = {
  "dismiss": "\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C8\u03B7"
};
export { $0898b4c153db2b77$exports as default };